import DirectusCmsProjectsApi from '../api/rest/directus-cms/projects';
import { projects } from '../stores/stores';
export async function listProjects(lang) {
    const api = DirectusCmsProjectsApi.getInstance();
    await api
        .listProjects(lang)
        .then(resp => {
        projects.set(resp.projects);
    })
        .catch(error => {
        console.log('Error fetching projects of page', error);
    });
}
